import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/** Invalida query staff quando Socket o altri eventi lo richiedono. */
export function useStaffMessagingInvalidation() {
  const qc = useQueryClient();
  useEffect(() => {
    const fn = () => {
      void qc.invalidateQueries({ queryKey: ['staff-messaging'] });
    };
    window.addEventListener('staff-messaging:invalidate', fn);
    return () => window.removeEventListener('staff-messaging:invalidate', fn);
  }, [qc]);
}
